export const NEWSLETTER_SUB_REQUEST = 'NEWSLETTER_SUB_REQUEST';
export const NEWSLETTER_SUB_SUCCESS = 'NEWSLETTER_SUB_SUCCESS';
export const NEWSLETTER_SUB_FAIL = 'NEWSLETTER_SUB_FAIL';
export const NEWSLETTER_SUB_RESET = 'NEWSLETTER_SUB_RESET';

export const NEWSLETTER_UNSUB_REQUEST = 'NEWSLETTER_UNSUB_REQUEST';
export const NEWSLETTER_UNSUB_SUCCESS = 'NEWSLETTER_UNSUB_SUCCESS';
export const NEWSLETTER_UNSUB_FAIL = 'NEWSLETTER_UNSUB_FAIL';
export const NEWSLETTER_UNSUB_RESET = 'NEWSLETTER_UNSUB_RESET';
